<template>
  <md-layout class='preexp-layout'>
  
    <md-layout md-flex="15"></md-layout>
    <md-layout  md-column md-gutter md-vertical-align="center" md-align="center">
  
    <h1 class="exp_desc">Experiment is about to start. You'll have 5 seconds on each molecule</h1>
    <md-button class="md-raised md-accent btn-start" @click="gotoExperiment">Start Experiment</md-button>
    
    </md-layout>
    
    <md-layout md-flex="15"></md-layout>
  </md-layout>

</template>

<script>
export default {
  name: 'pre-experiment',
  props: ['experiment_type'],
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods: {
	  gotoExperiment: function(){
		  this.$router.push({name: 'experiment',  params: { 'experiment_type': this.experiment_type }});
      }
    
    }
}

</script>

<style >
.preexp-layout {
    height:100%;
    background-image:    url(../assets/exp_start_back.png);
    background-size:     cover;                      
    background-repeat:   no-repeat;
    background-position: center center;              
}

.btn-start {
    margin-top: 50px;
    font-size: 2vw;
    padding: .9vw;
    border-radius: 5px;
    color: #fff !important;

}
.exp_desc{
    color: #fff200;
    padding-top: 40%;
    font-size: 2vw;  
}
</style>


// WEBPACK FOOTER //
// PreExperiment.vue?4a044630